<template lang="pug">
.form-change-email
  .form(
    v-if="!hasChangedEmail"
  )
    //- .form__elem
    //-   .form-elem.form-elem_horizontal
    //-     .form-elem__title Старый логин
    //-     .form-elem__body
    //-       input.input.input_full(
    //-       type="email"
    //-       )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errors.new_email }"
      )
        .form-elem__title Новый e-mail
        .form-elem__body
          input.input.input_full(
            type="email"
            v-model="new_email"
            v-on:keyup="keymonitor"
          )
    .form__elem.form__elem_button
      .form-elem
        .form-elem__body
          button.button.button_paint-main(
            @click.prevent="onChangeEmail($event)"
          ) Изменить e-mail
        .form-elem__error(v-if="errorMsg.length > 0") {{ errorMsg }}
  .form(
    v-else
  )
    h3 Мы отправили вам на почту {{ new_email }} инструкцию по смене e-mail.
    .form__elem.form__elem_button
      .form-elem
        .form-elem__body
          button.button(
          @click.prevent="onCancelChangeEmail()"
          ) Отмена

</template>
<script>
import {mapActions} from "vuex";

export default {
  name: "LoginChangeForm",
  components: {},
  data: () => ({
    hasChangedEmail: false,
    new_email: "",
    errors: {
      new_email: false
    },
    errorMsg: ""
  }),
  computed: {
    confirm_new_email_token() {
      return this.$route.query.confirm_new_email_token;
    }
  },
  methods: {
    ...mapActions(["getSource", "changeEmail", "confirmChangeEmail", "cancelChangeEmail"]),
    keymonitor() {
      this.errors.new_email = false;
      this.errorMsg = "";
    },
    onChangeEmail(e) {
      e.preventDefault();
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!reg.test(this.new_email)) {
        this.errors.new_email = true;
        return;
      }
      this.changeEmail({new_email: this.new_email}).then(res => {
        if (res.status === 200) {
          this.hasChangedEmail = true;
        }
        if (res.status === 400) {
          this.errors.new_email = true;
          this.errorMsg = "Этот e-mail уже занят";
        }
      });
    },
    onCancelChangeEmail() {
      this.cancelChangeEmail().then(res => {
        if (res.status == 204) {
          this.hasChangedEmail = false;
        }
      });
    }
  },
  mounted() {
    if (this.confirm_new_email_token) {
      this.confirmChangeEmail({
        token: this.confirm_new_email_token
      }).then(res => {
        if (res.status === 200) {
          this.$root.$emit("onShowNotificationModal", {
            text: "E-mail обновился"
          });
          const query = Object.assign({}, this.$route.query);
          delete query.confirm_new_email_token;
          this.$router.replace({query});
        }
      });
    } else {
      this.getSource({
        url: "/api/users/change-email/"
      }).then(res => {
        this.new_email = res.new_email;
        if (res.new_email.length > 0) {
          this.hasChangedEmail = true;
        }
      });
    }
  }
};
</script>
